import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ListClients } from "./ClientStore";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../components/Modal";
import { getOrganizations } from "../organizations/OrganizationStore";

import { find, get } from "lodash";

export const ManageExternalClient = ({ user, policies }) => {
    const [clients, setClients] = React.useState([]);
    const [organizations, setOrganizations] = React.useState([]);

    React.useEffect(() => {
        ListClients().then((res) => {
            setClients(res.data);
        });
        getOrganizations((organizations) => {
            setOrganizations(organizations);
        });
    }, []);

    const navigate = useNavigate();

    return (
        <>
            <div className="mb-6">
                <h3 className="text-lg font-medium text-gray-900">Manage external client access to your organization</h3>
            </div>
            
            <Table>
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "70%" }}>Client</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {clients.map((client) => (
                        <tr key={client.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">
                                    {get(find(organizations, { id: client.organization }), "name", "No Organization")} - {client.name}
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => {
                                        navigate(`/organizations/clients/${client.id}/permissions`);
                                    }}
                                    className="text-yellow-600 border-yellow-600 hover:bg-yellow-50"
                                >
                                    <FontAwesomeIcon icon={["fad", "users-cog"]}></FontAwesomeIcon>
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    );
};
